import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { DataTestBuilderModule } from '../data-test-builder/data-test-builder.module';
import { DataTestBuilderContainerComponent } from './data-test-builder-container.component';

@NgModule({
  declarations: [DataTestBuilderContainerComponent],
  imports: [CommonModule, DataTestBuilderModule, MatProgressBarModule],
  exports: [DataTestBuilderContainerComponent],
})
export class DataTestBuilderContainerModule {}
